<template>
  <div class="remind-card">
    <div class="remind-card-left">
      <div class="remind-card-left__title">
        {{ item.title }}
      </div>
      <div v-if="isShowContent" class="remind-card-left__desc">
        <div class="prefix">描述：</div>
        <div class="content">
          {{ item.content }}
        </div>
      </div>
      <div class="remind-card-left__desc">
        <div class="prefix">执行时间：</div>
        <div class="value" :class="{ isTimeOut: item.isTimeOut === 1 }">
          {{ convertTimestamp(item.time * 1000) }}
        </div>
      </div>
      <div class="remind-card-left__desc">
        <div class="prefix">执行人：</div>
        <div class="value">{{ item.executor.name }}</div>
      </div>
    </div>
    <div v-if="!item.todoSuggestTag" class="remind-card-right">
      <el-button style="margin-left: 12px" @click="handleCreate">创建</el-button>
    </div>
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import { getCommunicatePlanBaseInfo } from '@/api'
import { ElMessage } from 'element-plus'
// import xbb from 'xbb-sdk'

const props = defineProps({
  item: {
    type: Object,
    default: () => {}
  },
  attributes: {
    type: Object,
    default: () => ({})
  }
})

const handleCreate = async () => {
  getCommunicatePlanBaseInfo({
    customerInfo: {
      customerId: props.attributes.customer.customerId,
      customerName: props.attributes.customer.customerName
    },
    chatRecordId: props.attributes.id,
    index: props.attributes.index,
    sourceType: 2
  })
    .then(() => {
      // eslint-disable-next-line vue/no-mutating-props
      props.item.todoSuggestTag = 1
      ElMessage.success('操作成功')
    })
    .catch(() => {})
  // xbb.useComponent({
  //   action: 'addNewForm',
  //   data: {
  //       appId: res.result.formInfo.appId,
  //       saasMark: res.result.formInfo.saasMark,
  //       businessType: res.result.formInfo.businessType,
  //       subBusinessType: res.result.formInfo.businessSubType,
  //       formId: res.result.formInfo.formId,
  //       menuId: res.result.formInfo.menuId,
  //       formData: res.result.dataInfo
  //   }
  // }).then(result => {
  //   console.log(result)
  // })
}

function convertTimestamp(timestamp) {
  const now = new Date()
  const currentYear = now.getFullYear()
  const date = new Date(timestamp)
  const year = date.getFullYear()
  function formatNumber(num) {
    return String(num).padStart(2, '0')
  }

  const month = formatNumber(date.getMonth() + 1)
  const day = formatNumber(date.getDate())
  const hours = formatNumber(date.getHours())
  const minutes = formatNumber(date.getMinutes())
  if (year === currentYear) {
    return `${month}月${day}日 ${hours}:${minutes}`
  }
  return `${year}年${month}月${day}日 ${hours}:${minutes}`
}

onMounted(() => {})
</script>

<style lang="less" scoped>
.remind-card {
  padding: 12px;
  box-sizing: border-box;
  border: 1px solid #f2f3f5;
  display: flex;
  border-radius: 8px;
  margin-top: 12px;
  .remind-card-left {
    flex: 1;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    .remind-card-left__title {
      line-height: 20px;
      font-size: 14px;
      font-weight: 600;
      color: #323233;
      margin-bottom: 8px;
    }
    .remind-card-left__subtitle {
      font-size: 13px;
      color: #323233;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      margin-bottom: 8px;
    }
    .remind-card-left__desc {
      display: flex;
      line-height: 20px;
      margin-bottom: 4px;
      .prefix {
        flex: 0 0 auto;
        font-size: 13px;
        color: #969799;
        margin-right: 4px;
      }
      .value {
        font-size: 13px;
        color: #323233;
      }
      .content {
        font-size: 13px;
        color: #323233;
        flex: 1;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
      }
      .isTimeOut {
        color: #f54e4e;
      }
      .btn {
        font-family: PingFang SC;
        font-size: 13px;
        letter-spacing: 0em;
        color: #248df5;
        margin-left: 4px;
      }
    }
  }
  .remind-card-right {
    flex: 0 0 auto;
    display: flex;
    align-items: center;
  }
}
</style>
